export const WELCOME_EXAMPLE_QUESTION_KEYS = ['1', '2', '3', '4'];

export const getWelcomeExampleQuestions = (t) =>
  WELCOME_EXAMPLE_QUESTION_KEYS.map((key) => t(`chat.exampleQuestions.${key}`));
